import { QUERY_PARAM_TERM_UPDATED } from './constants/ActionTypes';
export const updateQueryParamTerm = payload => ({
  type: QUERY_PARAM_TERM_UPDATED,
  payload
});